/* eslint-disable stylistic/comma-dangle */
/* eslint-disable sort-keys */
/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
  baseStyle: {
    container: {
      minWidth: 'xs',
      width: 'full',
      boxShadow: 'base',
      backgroundColor: 'white',
    },
    content: {
      maxWidth: 'container.xxxl',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingLeft: [4, 4, 6, 8],
      paddingRight: [4, 4, 6, 8],
      paddingTop: [1, 1, 2, 4],
      paddingBottom: [3, 3, 2, 4],
    },
    searchContainer: {
      order: [2, 2, 2, 'inherit'],
      width: ['full', 'full', 'full', 60],
      marginRight: [0, 0, 0, 4],
      marginBottom: [1, 1, 2, 0],
    },
    bodyContainer: {
      flex: '1',
    },
    logo: {
      width: '100%',
      height: 'auto',
    },
    iconLogo: {
      maxWidth: {base: '76px', lg: '112px'},
    },
    icons: {
      marginBottom: [1, 1, 2, 0],
    },
    actionsContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    accountIconDesktop: {
      display: {base: 'none', lg: 'inline'},
      height: 11,
      minWidth: 'auto',
      cursor: 'pointer',
      alignSelf: ['self-start', 'self-start', 'self-start', 'auto'],
      _focus: {
        boxShadow: 'outline',
      },
      _focusVisible: {
        outline: 0,
      },
    },
    arrowDown: {
      height: 11,
      minWidth: 'auto',
      marginRight: 0,
      alignSelf: ['self-start', 'self-start', 'self-start', 'auto'],
      cursor: 'pointer',
      _focus: {
        boxShadow: 'outline',
      },
      _focusVisible: {
        outline: 0,
      },
      display: ['none', 'none', 'none', 'block'],
    },
    wishlistIconDesktop: {
      display: {base: 'none', lg: 'inline'},
      marginLeft: 2,
    },
    signout: {
      width: '100%',
      borderRadius: '4px',
      height: 11,
      padding: 4,
      py: 3,
      marginTop: 1,
      _hover: {
        background: 'gray.50',
      },
    },
    signoutText: {
      fontSize: 'sm',
      fontWeight: 'normal',
    },
    signoutIcon: {
      marginRight: 2,
    },
    languageIconDesktop: {
      display: {base: 'none', lg: 'inline-flex'},
      sx: {
        '.chakra-icon': {
          width: '24px',
          height: '24px',
        }
      }
    },
  },
  parts: ['container', 'content', 'actionsContainer', 'searchContainer', 'bodyContainer', 'logo', 'icons', 'signout', 'languageIconDesktop', 'wishlistIconDesktop'],
};
